import Footer from "@/components/Footer";
import { useTableFiltersCursor } from "@/hooks/useTableFiltersCursor";
import { Box } from "@chakra-ui/react";
import { useState } from "react";
import { CLAIM_TABLE_COLUMNS } from "./columns";
import ClaimDetailModal from "./components/ClaimDetailModal";
import Filters from "./components/Filters";
import SummaryCards from "./components/SummaryCards";
import Table from "./components/Table";
import { Claim, ClaimFilters } from "./types";
import { useFetchClaims } from "./useFetchClaims";
import { useFetchClaimsSummary } from "./useFetchClaimsSummary";

const TABLE_KEY = "protectClaims";

const ClaimedTab = (): JSX.Element => {
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<ClaimFilters>(TABLE_KEY);
  const { claims, nextCursor, isLoading } = useFetchClaims(
    queryFilters,
    cursor
  );
  const { summary } = useFetchClaimsSummary();
  const [selected, setSelected] = useState<{
    claim: Claim;
    confirmDismiss: boolean;
  }>();

  return (
    <Box display="flex" flexDirection="column" gap="1rem" flex="1" minH={0}>
      <SummaryCards summary={summary} />
      <Filters queryFilters={queryFilters} setQueryFilters={setQueryFilters} />
      <Table
        claims={claims}
        isLoading={isLoading}
        onSelect={(claim) => setSelected({ claim, confirmDismiss: false })}
        onDismiss={(claim) => setSelected({ claim, confirmDismiss: true })}
      />
      <ClaimDetailModal
        open={!!selected}
        onClose={() => setSelected(undefined)}
        claim={selected?.claim}
        confirmDismiss={selected?.confirmDismiss}
      />
      <Footer
        tableProps={{
          fileName: "reclamaciones",
          items: claims,
          columns: CLAIM_TABLE_COLUMNS,
          pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
        }}
      />
    </Box>
  );
};

export default ClaimedTab;
